import React from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import { getJigsawRecordingCaptureFrame } from "../recordingCaptureFrame";

/** Full-viewport shell for `/mobile/jigsaw/*` (no site header). */
export default function Layout({ children }) {
    const { pathname } = useLocation();
    const captureFrame = getJigsawRecordingCaptureFrame(pathname);
    const isCaptureBoard =
        Boolean(captureFrame) && pathname.includes("/board/");

    return (
        <Box
            sx={{
                boxSizing: "border-box",
                overflow: "hidden",
                ...(isCaptureBoard && captureFrame
                    ? {
                          width: captureFrame.width,
                          height: captureFrame.height,
                          minWidth: captureFrame.width,
                          minHeight: captureFrame.height,
                          maxWidth: captureFrame.width,
                          maxHeight: captureFrame.height,
                      }
                    : {
                          minHeight: "100%",
                          height: "100%",
                          width: "100%",
                          overflowX: "hidden",
                          // OBS Browser Source: prefer % over dvh/vh (CEF often misreports).
                          "@supports (height: 100dvh)": {
                              minHeight: "100dvh",
                          },
                      }),
            }}
        >
            {children}
        </Box>
    );
}
